import { __rest } from "tslib";
/**
 * desc 自定义表格td
 * */
import React, { Component } from 'react';
import { Form } from 'antd';
import TableCellIndex from './TableCellIndex';
import TableCellInput from './TableCellInput';
import TableCellOperate from './TableCellOperate';
import TableCellOPrice from './TableCellPrice';
import { dispatch, getState } from '@@/store';
export const EditableContext = React.createContext({});
// desc 可编辑CELL 的ROW 透传form以供CELL使用
const EditableRow = (_a) => {
    var { form, index } = _a, props = __rest(_a, ["form", "index"]);
    return (<EditableContext.Provider value={form}>
      <tr {...props}/>
    </EditableContext.Provider>);
};
export const EditableFormRow = Form.create({
    onFieldsChange: (props, changedFields, allFields) => {
        const validateList = getState().session.validateList;
        validateList[props['data-row-key']] = allFields;
        dispatch.session.SET_STATE({
            validateList,
        });
    },
})(EditableRow);
const formList = {};
// desc 使用this.props.form通过Context透传下来
class EditableCell extends Component {
    constructor(props) {
        super(props);
        this.form = null;
        this.input = null;
    }
    render() {
        const _a = this.props, { td = {} } = _a, restProps = __rest(_a, ["td"]);
        return (<td className={td.tdClassName} {...restProps}>
        <EditableContext.Consumer>
          {(form) => {
            if (!this.form) {
                this.form = form;
            }
            // 缓存每行的form
            if (td.rowData && td.rowData.auctionId) {
                !formList[td.rowData.auctionId] && (formList[td.rowData.auctionId] = this.form);
            }
            let Child;
            switch (td.tdType) {
                case 'editable':
                    Child = (<TableCellInput td={Object.assign(Object.assign({}, td), { form: this.form })}>
                      {this.props.children}
                    </TableCellInput>);
                    break;
                case 'editablePrice':
                    Child = (<TableCellOPrice td={{
                        renderData: td.renderData,
                        form: this.form,
                    }}/>);
                    break;
                case 'editableIndex':
                    Child = (<TableCellIndex td={td}>
                      {this.props.children}
                    </TableCellIndex>);
                    break;
                case 'operate':
                    Child = <TableCellOperate td={td}/>;
                    break;
                default:
                    Child = this.props.children;
                    break;
            }
            return Child;
        }}
        </EditableContext.Consumer>
      </td>);
    }
}
export default EditableCell;
